<template>
  <div :class="stepNumber == 2 ? 'block' : 'hidden'">
    <h1 class="registration-form-layout__title">{{ spFormTitle }}</h1>

    <div class="search-preferences-form registration-form-layout registration-form-layout--green flex">
      
      <p class="registration-form-layout__note"><b>{{locales && locales.subscription && locales.subscription.search_preferences}}</b> {{locales && locales.subscription && locales.subscription.more_accurate_offers}} {{locales && locales.subscription && locales.subscription.you_can_skip}}</p>

      <theme-location-dropdown 
        v-validate="`required`"
        :isRequired="true"
        name='location_id[]' 
        :label="spCityTitle"
        :placeholder="locales && locales.subscription && locales.subscription.add_location"
        endpoint="/admin/autocomplete/locations"
      ></theme-location-dropdown>

      <theme-districts-dropdown 
        :data="[]"
        name='districts[]' 
        :label="spDistrictTitle"
        :placeholder="spDistrictPlaceholder"
        :district-input="true"
      ></theme-districts-dropdown>

      <theme-select
        :name="'distance'"
        :label="spDistanceTitle"
        :value="spDistanceValue"
        :options="spDistanceOptions"
      ></theme-select>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
        <theme-select
          name="property_type_id"
          :label="spPropertyTypeTitle"
          :value="spPropertyTypeValue"
          :options="spPropertyTypeOptions"
          :zero-option="spNoPreference"
        ></theme-select>

        <theme-select
          :label="spBedroomsTitle"
          :value="spBedroomsValue"
          name="min_number_of_bedrooms"
          :options="spBedroomsOptions"
        ></theme-select>

        <theme-select
          :label="spInteriorTitle"
          name="furnishing_id"
          :value="spInteriorValue"
          :zero-option="spNoPreference"
          :options="spInteriorOptions"
        ></theme-select>

        <theme-select
            name="min_area"
            :label="spSurfaceTitle"
            :value="spSurfaceValue"
            :options="spSurfaceOptions"
        ></theme-select>
      </div>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
        <theme-checkboxes
          class="form__radio"
          :options="{ '1': 'Suitable for sharing (more tenants)' }"
          name="require_beeing_sharable"
          :boldLabel="true"
        ></theme-checkboxes>

        <theme-checkboxes
          class="form__radio"
          :options="{ '1': `${spParkingSpaceTitle} <div class='divider-vert'></div> <a class='hover:underline' target='_blank' href=${spParkingSpaceLink}>${spParkingSpaceLinkText} <span style='padding-left: 8px; font-size: 16px;' class='icon-external'></span></a>` }"
          :name="'require_parking'"
          :boldLabel="true"
        ></theme-checkboxes>
      </div>

      <div class="divider"></div>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
        <theme-select
          name="min_price"
          :label="spRentalPriceFromTitle"
          :value="spRentalPriceFromValue"
          :options="spRentalPriceFromOptions"
        ></theme-select>

        <theme-select
          :name="'max_price'"
          :label="spRentalPriceToTitle"
          :value="spRentalPriceToValue"
          :options="spRentalPriceToOptions"
        ></theme-select>

        <theme-select
          name="rental_period_id"
          :label="spRentPeriodTitle"
          :value="spRentPeriodValue"
          :zero-option="spNoPreference"
          :options="spRentPeriodOptions"
        ></theme-select>

        <!-- :value="spStartDateRentValue" -->
        <theme-calendar
          :label="spStartDateRentTitle"
          name="rental_starts_at"
          :placeholder="spStartDateRentPlaceholder"
        ></theme-calendar>
      </div>

      <theme-textarea
        :label="spExtraInformationTitle"
        name="searchprofile_subscriber_note"
        rows="6"
      ></theme-textarea>

      <theme-checkboxes
        class="form__radio"
        :options="{ '1': requestSrc }"
        name="request_src"
        :additionalHtml="requestSrcInfo"
        :bigLabel="true"
      ></theme-checkboxes>

      <button
        id="submitSearchPreferencesFormBtn"
        class="theme-btn theme-btn--block theme-btn--primary"
        type="submit"
        @click.prevent="submitForm"
      >
        {{ commonSubmit }}
      </button>

    </div>
</div>
</template>

<script>
import $ from "jquery";
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";

import ThemeInput from "./ThemeInput.vue";
import ThemeCheckboxes from "./ThemeCheckboxes.vue";
import FormLocationDropdown from "./ThemeLocationDropdown.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import ThemeSelect from "./ThemeSelect.vue";
import ThemeTextarea from "./ThemeTextarea.vue";
// import { locales } from "moment";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ThemeInput,
    ThemeCheckboxes,
    FormLocationDropdown,
    ThemeCalendar,
    ThemeSelect,
    ThemeTextarea,
  },
  // data() {},
  computed: {
    ...mapGetters(["locales"]),
    stepNumber: function() {
      return this.$store.state.registrationStep.stepNumber;
    },
  },
  props: {
    spFormTitle: {
			default: '',
			type: String
		},
    spNoPreference: {
			default: '',
			type: String
		},
    spDistrictTitle: {
			default: '',
			type: String
		},
    spDistrictPlaceholder: {
			default: '',
			type: String
		},
    spDistanceTitle: {
			default: '',
			type: String
		},
    spDistanceOptions: {
			default: () => { },
			type: Object
		},
		spDistanceValue: {
			default: '',
			type: String
		},
    spPropertyTypeTitle: {
			default: '',
			type: String
		},
		spPropertyTypeOptions: {
			default: () => { },
			type: Object
		},
		spPropertyTypeValue: {
			default: '',
			type: String
		},
    spBedroomsTitle: {
			default: '',
			type: String
		},
		spBedroomsOptions: {
			default: () => { },
			type: Object
		},
		spBedroomsValue: {
			default: '',
			type: String
		},
    spInteriorTitle: {
			default: '',
			type: String
		},
		spInteriorOptions: {
			default: () => { },
			type: Object
		},
		spInteriorValue: {
			default: '',
			type: String
		},
    spSurfaceTitle: {
			default: '',
			type: String
		},
		spSurfaceOptions: {
			default: () => { },
			type: Object
		},
		spSurfaceValue: {
			default: '',
			type: String
		},
    spRentalPriceFromTitle: {
			default: '',
			type: String
		},
		spRentalPriceFromOptions: {
			default: () => { },
			type: Object
		},
		spRentalPriceFromValue: {
			default: '',
			type: String
		},
		spRentalPriceToTitle: {
			default: '',
			type: String
		},
		spRentalPriceToOptions: {
			default: () => { },
			type: Object
		},
		spRentalPriceToValue: {
			default: '',
			type: String
		},
    spRentPeriodTitle: {
			default: '',
			type: String
		},
		spRentPeriodOptions: {
			default: () => { },
			type: Object
		},
		spRentPeriodValue: {
			default: '',
			type: String
		},
    spStartDateRentTitle: {
			default: '',
			type: String
		},
		spStartDateRentValue: {
			default: '',
			type: String
		},
		spStartDateRentPlaceholder: {
			default: '',
			type: String
		},
    spExtraInformationTitle: {
			default: '',
			type: String
		},
    spCityTitle: {
			default: '',
			type: String
		},
    spParkingSpaceTitle: {
			default: '',
			type: String
		},
    spParkingSpaceLink: {
			default: '#',
			type: String
		},
    spParkingSpaceLinkText: {
			default: '',
			type: String
		},
    requestSrc: {
      default: "",
      type: String,
    },
    requestSrcInfo: {
      default: "",
      type: String,
    },
    commonSubmit: {
      default: "",
      type: String,
    },
  },
  methods: {
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          const form = $("#form");
          const data = form.serialize();
          const element = document.getElementById("submitSearchPreferencesFormBtn");

          element.classList.add("disabled-state");
          setTimeout(function () {
            element.classList.remove("disabled-state");
          }, 2000);

          $.ajax({
            url: form.attr("action"),
            method: "post",
            data: data,
            success: function (result) {
              that.isSubmitInProgress = false;
              if (result && result.status && result.status == "error") {
                var message = result.message;
                sweetalert(window.app.locales.common.error, message, "error");
                // sweetalert('Erorr in fetch request', 'Please, try again later', "error");
              } else {
                sweetalert(
                  window.app.locales.common.success,
                  window.app.locales.common.success_candidate_subscribe,
                  "success"
                ).then((res) => {
                  window.location.replace(result.url);
                });
              }
            },
            error: function (jqXHR, exception) {
              that.isSubmitInProgress = false;
              var message = jqXHR.responseJSON.message;
              sweetalert(window.app.locales.common.error, message, "error");
            },
          });
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },

  },
}
</script>


// WEBPACK FOOTER //
// resources/js/components/SearchPreferencesForm.vue